<!-- Ask Bob — Standalone Widget -->
<div class="rounded-3xl bg-[#E6EAFE] p-6 justify-between flex flex-col  gap-2 min-w-0 h-full">
    <!-- Header -->
    <div class="flex items-center gap-2 font-semibold text-sm text-gray-900">
        <span>Ask Bob - Standalone</span>
        <i class="pi pi-info-circle text-xs text-gray-400"
            pTooltip="Displays Bob Standalone activity — conversations held, files generated, documents analyzed, and mode usage patterns"
            tooltipPosition="top"></i>
    </div>

    <div class="flex flex-col gap-4">
        <!-- Row 1: Conversations + Documents analyzed -->
        <div class="grid grid-cols-2 gap-3 min-w-0">
            <div class="rounded-2xl bg-white border shadow-sm p-4 min-w-0">
                <div class="text-sm font-semibold ">Conversations</div>
                <div class="text-3xl font-bold text-gray-900 mt-1">{{ data()?.conversations ?? 0 }}</div>
                <div class="text-[0.65rem] text-gray-400">new chat threads</div>
            </div>
            <div class="rounded-2xl bg-white border border-gray-200 shadow-sm p-4 min-w-0">
                <div class="text-sm font-semibold">Documents analyzed</div>
                <div class="text-3xl font-bold text-gray-900 mt-1">{{ data()?.documentsAnalyzed ?? 0 }}</div>
                <div class="text-[0.65rem] text-gray-400">uploaded to Bob chats</div>
            </div>
        </div>

        <div class="rounded-2xl bg-white border  shadow-sm p-4">
            <div class="text-sm font-semibold">Outputs generated</div>
            <div class="flex flex-row justify-between  items-center gap-4">
                <div class="flex flex-col gap-2 items-start">
                    <div class="text-3xl font-bold text-gray-900 mt-1">{{ data()?.outputs?.total ?? 0 }}</div>
                    <div class="text-sm text-gray-400">total files generated</div>
                </div>
                <div class="flex flex-col gap-1 items-start flex-1 min-w-0">
                    <div class="flex w-full h-1.5 rounded-full overflow-hidden mt-2 bg-gray-100">
                        <div class="h-full bg-rose-400" [style.width.%]="outputsSplit().pdf"></div>
                        <div class="h-full bg-amber-400" [style.width.%]="outputsSplit().docx"></div>
                        <div class="h-full bg-emerald-400" [style.width.%]="outputsSplit().xlsx"></div>
                        <div class="h-full bg-gray-400" [style.width.%]="outputsSplit().others"></div>
                    </div>
                    <div class="flex flex-wrap items-center gap-3 text-[0.65rem] text-gray-500 mt-2">
                        <span class="inline-flex items-center gap-1">
                            <span class="w-2 h-2 rounded-full bg-rose-400"></span>
                            {{ data()?.outputs?.pdf ?? 0 }} PDF
                        </span>
                        <span class="inline-flex items-center gap-1">
                            <span class="w-2 h-2 rounded-full bg-amber-400"></span>
                            {{ data()?.outputs?.docx ?? 0 }} DOCX
                        </span>
                        <span class="inline-flex items-center gap-1">
                            <span class="w-2 h-2 rounded-full bg-emerald-400"></span>
                            {{ data()?.outputs?.xlsx ?? 0 }} XLSX
                        </span>
                        <span class="inline-flex items-center gap-1">
                            <span class="w-2 h-2 rounded-full bg-gray-400"></span>
                            {{ data()?.outputs?.others ?? 0 }} Other
                        </span>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <hr class="border-gray-300" />

    <!-- Mode usage -->
    <div class="flex flex-col gap-2.5">
        <div class="flex items-center justify-between text-sm text-zinc-900">
            <span class="font-normal">Mode usage across conversations</span>
            <div class="flex items-center gap-3">
                <div class="h-6 px-2 bg-indigo-300 rounded-lg flex items-center text-sm font-medium text-zinc-900">
                    {{ data()?.modeSplit?.ask ?? 0 }}% Ask
                </div>
                <div class="h-6 px-2 bg-blue-600 rounded-lg flex items-center text-sm font-medium text-white">
                    {{ data()?.modeSplit?.agentic ?? 0 }}% Agentic
                </div>
            </div>
        </div>
        <div class="flex w-full h-2.5 bg-indigo-300 rounded-md overflow-hidden">
            <div class="h-full bg-blue-600 rounded-tr-md rounded-br-md ml-auto"
                [style.width.%]="data()?.modeSplit?.agentic ?? 0"></div>
        </div>
        <div class="flex items-center gap-2 text-sm text-zinc-900">
            <span class="inline-flex items-center gap-1.5">
                <span class="size-2.5 rounded-full bg-indigo-200"></span> Ask mode
            </span>
            <span class="inline-flex items-center gap-1.5">
                <span class="size-2.5 rounded-full bg-blue-600"></span> Agentic mode
            </span>
        </div>
    </div>
</div>